<template>
  <section>
    <validation-observer ref="formValidator">
      <page-header
        :on-return="() => $router.go(-1)"
        :on-save="save"
        :page="page"
      />

      <board class="mb-4" :details="board" />

      <section-title title="Información General" />

      <div class="row mb-4 pl-3">
        <div class="col-sm">
          <validation-provider
            v-slot="{ errors }"
            name="Teléfono"
            rules="required|length:11"
          >
            <custom-input
              v-model="model.locationTelephoneNo"
              :custom-error-msg="validationMessages.required"
              :error="errors[0]"
              label="Teléfono:"
              mask-type="Phone"
              placeholder="(___) ___-____"
            />
          </validation-provider>
        </div>
        <div class="col-sm">
          <custom-input
            v-model="model.locationTelephoneFaxNo"
            label="Fax:"
            mask-type="Phone"
            placeholder="(___) ___-____"
          />
        </div>
        <div class="col-sm">
          <custom-input
            v-model="model.locationWebsiteUrl"
            label="Dirección Web:"
            placeholder="www.websitedomain.com"
          />
        </div>
      </div>

      <section-title title="Información de Localización" />

      <div class="row mb-4 pl-3">
        <div class="col-md-4 col-sm-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              ref="locationTypeRef"
              v-model="locationType"
              :clearable="false"
              :custom-error-msg="validationMessages.select"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Tipo de Localización:"
              :options="locationTypes"
              placeholder="Seleccione"
              @input="setLocationTypeValue"
            />
          </validation-provider>
        </div>
        <div
          v-if="showProviderOfficeSection || isAssistedTherapy"
          class="col-md-4 col-sm-12"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              v-model="model.locationName"
              :custom-error-msg="validationMessages.required"
              :error="errors[0]"
              label="Nombre:"
            />
          </validation-provider>
        </div>
        <div v-if="showCSEESection" class="col-md-4 col-sm-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="center"
              :custom-error-msg="validationMessages.select"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Centro:"
              :options="centers"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div v-if="showCAATSection" class="col-md-4 col-sm-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="caat"
              :custom-error-msg="validationMessages.select"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="CAAT:"
              :options="caatCenters"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div v-if="showCAATSection" class="col-md-4 col-sm-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="caatMunicipality"
              :clearable="false"
              :custom-error-msg="validationMessages.select"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Municipio:"
              :options="caatMunicipalities"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div
          v-if="
            showProviderOfficeSection || showCSEESection || isAssistedTherapy
          "
          class="col-md-4 col-sm-12"
        >
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="municipality"
              :clearable="false"
              :custom-error-msg="validationMessages.select"
              :disabled="municipalityReadOnly"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Municipio:"
              :options="
                showProviderOfficeSection || isAssistedTherapy
                  ? municipalities
                  : centerMunicipalities
              "
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div v-if="showSchoolSection" class="col-md-4 col-sm-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="region"
              :custom-error-msg="validationMessages.select"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Región:"
              :options="regions"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div v-if="showSchoolSection" class="col-md-4 col-sm-12">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="district"
              :clearable="false"
              :custom-error-msg="validationMessages.select"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Distrito:"
              :options="districts"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div v-if="showSchoolSection" class="col-md-4 col-sm-12 mt-3">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="school"
              :custom-error-msg="validationMessages.select"
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Escuela:"
              :options="schools"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
      </div>

      <div v-if="showDemographicInfoSection" class="mb-5">
        <section-title title="Información de Dirección Física" />

        <div class="row mb-4 pl-3">
          <div class="col-sm">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="model.primayAddressInformation.addressLine1"
                :custom-error-msg="validationMessages.required"
                :error="errors[0]"
                label="Dirección (Línea 1):"
              />
            </validation-provider>
          </div>
          <div class="col-sm">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="addressMunicipality"
                :custom-error-msg="validationMessages.select"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Municipio:"
                :options="municipalities"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-sm">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="model.primayAddressInformation.zipCode"
                :custom-error-msg="validationMessages.required"
                :error="errors[0]"
                label="Código Postal:"
                mask-type="ZipcodeExt"
                placeholder="_____-____"
              />
            </validation-provider>
          </div>
        </div>

        <div class="row mb-4 pl-3">
          <div class="col-sm">
            <custom-input
              v-model="model.primayAddressInformation.addressLine2"
              label="Dirección (Línea 2):"
            />
          </div>
          <div class="col-sm">
            <validation-provider
              v-slot="{ errors }"
              :rules="{ regex: /(-?\d+(\.\d+)?)/ }"
            >
              <custom-input
                v-model="model.primayAddressInformation.gpsLatitudee"
                :custom-error-msg="validationMessages.invalidCoordinate"
                :error="errors[0]"
                label="Latitud:"
                placeholder="____._________"
              />
            </validation-provider>
          </div>
          <div class="col-sm">
            <validation-provider
              v-slot="{ errors }"
              :rules="{ regex: /(-?\d+(\.\d+)?)/ }"
            >
              <custom-input
                v-model="model.primayAddressInformation.gpsLongitude"
                :custom-error-msg="validationMessages.invalidCoordinate"
                :error="errors[0]"
                label="Longitud:"
                placeholder="____._________"
              />
            </validation-provider>
          </div>
        </div>

        <div class="row mb-4 pl-3">
          <div class="col-sm-12 col-md-4">
            <custom-input
              v-model="model.primayAddressInformation.addressLine3"
              label="Dirección (Línea 3):"
            />
          </div>
          <div class="col">
            <custom-input
              v-model="model.primayAddressInformation.addressDescription"
              label="Anotaciones Adicionales:"
              placeholder="Escribir información adicional de cómo llegar…"
            />
          </div>
        </div>

        <section-title title="Información de Contacto Primario" />

        <div class="mb-5 pl-3">
          <contact-information
            v-model="model.primaryContactInformation"
            :civil-statuses="civilStatuses"
          />
        </div>
      </div>
      <wrapper
        v-if="showHogarSection"
        :icon="{
          header: 'fas fa-map-marker-alt',
          inside: 'fas fa-plus',
        }"
        :label="{
          title: 'Municipio(s)',
          text: 'Añadir Municipio(s)',
          placeholder: 'Escriba aquí para buscar un municipio...',
          openMsg: 'Presione aquí para añadir Municipio(s) ',
          inner: 'Municipio(s) seleccionado(s)',
        }"
        :list="homeMunicipalities"
        :save="getSelectedHomeMunicipalities"
        :selected-items="wrapperSelection.model"
      />
    </validation-observer>
  </section>
</template>

<script>
import { PageHeader } from '@/shared/components/PageHeader/index';
import SectionTitle from '@/components/common/page/SectionTitle';
import CustomInput from '@/components/common/form/CustomInput';
import CustomDropDown from 'custom-drop-down';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import {
  getServiceLocationTypes,
  getlocationservicecompany,
  insertservicelocation,
  getCaats,
  getCaatsMunicipalities,
  getCivilStatuses,
} from '@/modules/provider/api.js';
import { getValidationMessages } from '@/modules/common/api.js';
import locationTypes from '@/utils/constants/locationTypes.js';
import {
  getMunicipalities,
  getSchools,
  getRegions,
  getCenters,
  getDistricts,
  getSchoolsAddress,
  getCenterAddress,
  getAvailableLocationHomeMunicipalities,
} from '@/modules/common/location.api';
import { ContactInformation } from './components';
import mixWait from '@/mixins/vue-loading.js';
import mixAlert from '@/mixins/alert.mixin.js';
import wrapper from '@/shared/components/MultiSelectionBadge/Wrapper.vue';

function addressInitialState() {
  return {
    addressId: null,
    addressName: '',
    addressDescription: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    zipCode: '',
    addressTypeCd: null,
    municipalityId: null,
    gpsLatitude: null,
    gpsLongitude: null,
    locationId: null,
  };
}

function contactinitialState() {
  return {
    id: null,
    email: '',
    nameFirst: '',
    nameInitial: '',
    nameLastMaternal: '',
    nameLastPaternal: '',
    telephoneHomeFaxNo: '',
    telephoneHomeNo: '',
    telephoneMobileNo: '',
    telephoneWorkFaxNo: '',
    telephoneWorkNo: '',
    telephoneWorkExtNo: '',
    websiteURL: '',
    workDepartmentName: '',
    workPositionTitle: '',
  };
}

export default {
  name: 'AddServiceLocation',
  components: {
    PageHeader,
    SectionTitle,
    CustomInput,
    CustomDropDown,
    ValidationProvider,
    ValidationObserver,
    ContactInformation,
    wrapper,
  },
  mixins: [mixAlert, mixWait],
  data() {
    return {
      civilStatuses: [],
      page: {
        title: 'Añadir Lugares de Servicio',
        icon: 'fas fa-user-tie',
        routes: [
          'Proveedor',
          'Lugares de Servicio',
          'Lugares de Servicio: Añadir',
        ],
      },
      boardData: {
        year: '',
        company: '',
        patronal: '',
        provider: '',
      },
      clearContactObject: {},
      clearAddressObject: {},
      locationType: null,
      center: null,
      caat: null,
      caatMunicipality: null,
      municipality: null,
      region: null,
      district: null,
      school: null,
      addressMunicipality: null,
      model: {
        locationFiscalYearId: null,
        fiscalYearId: null,
        locationId: null,
        locationName: '',
        locationSchoolId: null,
        locationSchoolName: '',
        centerId: null,
        centerName: '',
        locationTelephoneNo: '',
        locationTelephoneFaxNo: '',
        locationTypeId: null,
        locationTypeName: '',
        locationWebsiteUrl: '',
        schoolTypeId: null,
        schoolTypeName: '',
        caatId: null,
        caatMunicipalityId: null,
        locationMunicipalities: [],
        companyId: null,
        regionId: null,
        districtId: null,
        municipalityId: null,
        primayAddressInformation: addressInitialState(),
        primaryContactInformation: contactinitialState(),
        addresses: [],
        contacts: [],
        locationTypeOriginal: null,
      },
      //TODO: traer mensajes de backend
      validationMessages: {
        required: 'Campo Requerido',
        select: 'Favor Seleccione',
        invalidCoordinate: 'Coordenada inválida',
        invalidForm: 'Favor de completar la información solicitada.',
        successSave: '',
        invalidValue: 'Valor inválido.',
      },
      currentYearId: null,
      companyId: null,
      locationTypesConstants: locationTypes,
      locationTypes: [],
      municipalities: [],
      regions: [],
      districts: [],
      schools: [],
      centers: [],
      centerMunicipalities: [],
      caatCenters: [],
      caatMunicipalities: [],
      homeMunicipalities: [],
      selectedHomeMunicipalities: [],
      wrapperSelection: {
        listSelected: [],
        model: [],
      },
    };
  },

  computed: {
    board() {
      return [
        [
          {
            label: 'Año Fiscal:',
            icon: 'fas fa-ballot-check',
            data: this.boardData.year,
          },
          {
            label: 'Proveedor:',
            icon: 'fas fa-address-book',
            data: this.boardData.company,
            cols: 'col-sm-6',
          },
          {
            label: 'SSN Patronal:',
            icon: 'fas fa-ballot-check',
            data: this.boardData.patronal,
          },
          {
            label: 'Tipo de Proveedor:',
            icon: 'fas fa-address-book',
            data: this.boardData.provider,
          },
        ],
      ];
    },
    municipalityReadOnly() {
      return (
        this.locationType &&
        this.locationType.id == this.locationTypesConstants.CSEE
      );
    },
    showProviderOfficeSection() {
      return (
        this.locationType &&
        this.locationType.id == this.locationTypesConstants.OfficinaProveedor
      );
    },
    isAssistedTherapy() {
      return (
        (this.locationType &&
          this.locationType.id ==
            this.locationTypesConstants.CiberterapiaAsistida) ||
        this.model.locationTypeId ==
          this.locationTypesConstants.CiberterapiaAsistida
      );
    },
    showHogarSection() {
      return (
        this.locationType &&
        this.locationType.id == this.locationTypesConstants.Hogar
      );
    },
    showCAATSection() {
      return (
        this.locationType &&
        this.locationType.id == this.locationTypesConstants.CAAT
      );
    },
    showCSEESection() {
      return (
        this.locationType &&
        this.locationType.id == this.locationTypesConstants.CSEE
      );
    },
    showSchoolSection() {
      return (
        this.locationType &&
        this.locationType.id == this.locationTypesConstants.Escuela
      );
    },
    showDemographicInfoSection() {
      return (
        this.locationType &&
        this.locationType.id != this.locationTypesConstants.Hogar
      );
    },
  },
  watch: {
    center(newValue) {
      if (newValue != null) {
        this.model.centerId = newValue.id;
        this.municipality = null;
        this.centerMunicipalities = [];
        getMunicipalities({
          AcademicYearId: this.model.fiscalYearId,
          CenterId: this.model.centerId,
        }).then((res) => {
          this.centerMunicipalities = res;
        });
        this.setCenterAddress(this.model.centerId);
      }
    },
    caat(newValue) {
      if (newValue != null) {
        this.model.caatId = newValue.id;
        this.model.caatMunicipalityId = null;
        this.caatMunicipalities = [];
        getCaatsMunicipalities({ id: this.model.caatId }).then((res) => {
          this.caatMunicipalities = res;
        });
      }
    },
    caatMunicipality(newValue) {
      if (newValue != null) this.model.caatMunicipalityId = newValue.id;
    },
    municipality(newValue) {
      if (newValue != null) this.model.municipalityId = newValue.id;
    },
    region(newValue) {
      if (newValue != null) {
        this.model.regionId = newValue.id;
        this.district = null;
        this.school = null;
        this.districts = [];
        this.schools = [];
        this.model.primayAddressInformation = addressInitialState();
        this.addressMunicipality = null;
        getDistricts({
          AcademicYearId: this.model.fiscalYearId,
          RegionId: this.model.regionId,
        }).then((res) => {
          this.districts = res;
        });
      }
    },
    district(newValue) {
      if (newValue != null) {
        this.model.districtId = newValue.id;
        this.school = null;
        this.schools = [];
        getSchools({
          AcademicYearId: this.model.fiscalYearId,
          DistrictId: this.model.districtId,
          ...{
            SkipUserCompanyFlag: true,
          },
        }).then((res) => {
          this.schools = res;
        });
      }
    },
    school(newValue) {
      if (newValue != null) {
        this.model.locationSchoolId = newValue.id;
        this.setSchoolAddress(this.model.locationSchoolId);
      }
    },
    addressMunicipality(newValue) {
      if (newValue != null)
        this.model.primayAddressInformation.municipalityId = newValue.id;
    },
  },
  async mounted() {
    this.ShowWait();
    this.clearContactObject = Object.assign(
      {},
      this.model.primaryContactInformation
    );
    this.clearAddressObject = Object.assign(
      {},
      this.model.primayAddressInformation
    );
    this.model.fiscalYearId = parseInt(this.$route.params.fiscalYearId);
    this.model.companyId = parseInt(this.$route.params.companyId);
    getlocationservicecompany({
      fiscalYearId: this.model.fiscalYearId,
      companyId: this.model.companyId,
    }).then((res) => {
      this.boardData.year = res.fiscalYear;
      this.boardData.company = res.companyName;
      this.boardData.patronal = res.socialSecurityNo;
      this.boardData.provider = res.companyTypeName;
    });

    getServiceLocationTypes().then((resp) => {
      this.locationTypes = resp.data;
    });
    getMunicipalities({ AcademicYearId: this.model.fiscalYearId }).then(
      (res) => {
        this.municipalities = res;
        //this.homeMunicipalities = res.map(({ id, name, selected }) => ({ id, label: name, selected }))
      }
    );
    getAvailableLocationHomeMunicipalities({
      fiscalYearId: this.model.fiscalYearId,
      companyId: this.model.companyId,
    }).then((res) => {
      this.homeMunicipalities = res.map(({ id, name, selected }) => ({
        id,
        label: name,
        selected,
      }));
    });
    getRegions({ AcademicYearId: this.model.fiscalYearId }).then((res) => {
      this.regions = res;
    });
    getCenters({ AcademicYearId: this.model.fiscalYearId }).then((res) => {
      this.centers = res;
    });
    getCaats().then((res) => {
      this.caatCenters = res;
    });

    getValidationMessages('0636').then((res) => {
      this.validationMessages.successSave = res[0].name;
    });
    getValidationMessages('R160004').then((res) => {
      this.validationMessages.invalidForm = res[0].name;
    });
    this.HideWait();

    this.civilStatuses = (await getCivilStatuses()).data;
  },
  methods: {
    getSelectedHomeMunicipalities(selected) {
      this.wrapperSelection.model = selected;
      this.selectedHomeMunicipalities = selected;
      this.wrapperSelection.isOpen = false;
      this.wrapperSelection.readOnly = true;
    },
    async save() {
      let isValid = false;
      await this.$refs.formValidator.validate().then((res) => {
        isValid = res;
      });
      if (
        !(this.selectedHomeMunicipalities.length > 0) &&
        this.showHogarSection
      ) {
        this.ShowToast('Error', 'Debe añadir al menos un Municipio.', 'error');
        return;
      }
      if (!isValid) {
        this.ShowToast('Error', this.validationMessages.invalidForm, 'error');
        return;
      }
      //...
      this.model.addresses = [];
      this.model.contacts = [];
      let model = Object.assign({}, this.model);

      if (this.showHogarSection) {
        model.LocationMunicipalities = this.selectedHomeMunicipalities.map(
          ({ id }) => parseInt(id, 10)
        );
      } else {
        model.primayAddressInformation.gpsLongitude =
          model.primayAddressInformation.gpsLongitude != null
            ? parseFloat(model.primayAddressInformation.gpsLongitude)
            : null;
        model.primayAddressInformation.gpsLatitude =
          model.primayAddressInformation.gpsLatitude != null
            ? parseFloat(model.primayAddressInformation.gpsLatitude)
            : null;
        model.addresses.push(model.primayAddressInformation);
        model.contacts.push(model.primaryContactInformation);
      }
      await insertservicelocation(model)
        .then((res) => {
          if (res != null) {
            this.ShowToast('', this.validationMessages.successSave, 'success');
            this.goToDetail(res.data.locationFiscalYearId);
          }
        })
        .catch((error) =>
          this.ShowToast('', error.response.data.message, 'error')
        );
    },
    setCenterAddress(centerId) {
      getCenterAddress({ CenterId: centerId }).then((res) => {
        this.addressMunicipality = this.municipalities.find(
          (x) => x.id == res.municipalityId
        );
        this.model.primayAddressInformation.addressLine1 = res.addressLine1;
        this.model.primayAddressInformation.addressLine2 = res.addressLine2;
        this.model.primayAddressInformation.zipCode = res.zipCode;
        this.model.primayAddressInformation.gpsLatitude = res.gpsLatitude;
        this.model.primayAddressInformation.gpsLongitude = res.gpsLongitude;
        this.municipality = this.municipalities.find(
          (x) => x.id == res.municipalityId
        );
      });
    },
    setSchoolAddress(locationSchoolId) {
      getSchoolsAddress({ LocationSchoolId: locationSchoolId }).then((res) => {
        this.addressMunicipality = this.municipalities.find(
          (x) => x.id == res.municipalityId
        );
        this.model.primayAddressInformation.addressLine1 = res.addressLine1;
        this.model.primayAddressInformation.addressLine2 = res.addressLine2;
        this.model.primayAddressInformation.zipCode = res.zipCode;
        this.model.primayAddressInformation.gpsLatitude = res.gpsLatitude;
        this.model.primayAddressInformation.gpsLongitude = res.gpsLongitude;
      });
    },
    clear() {
      this.center = null;
      this.caat = null;
      this.caatMunicipality = null;
      this.municipality = null;
      this.region = null;
      this.district = null;
      this.school = null;
      this.addressMunicipality = null;

      this.caatMunicipalities = [];
      this.centerMunicipalities = [];
      this.districts = [];
      this.schools = [];
      this.model.primayAddressInformation = addressInitialState();
      this.model.primaryContactInformation = contactinitialState();
    },
    goToDetail(locationFiscalYearId) {
      this.$router.replace({
        name: 'EditProviderServiceLocation',
        params: {
          locationFiscalYearId: locationFiscalYearId,
        },
      });
    },
    async setLocationTypeValue(newValue) {
      if (this.model.locationTypeOriginal != null) {
        if (newValue != this.model.locationTypeOriginal) {
          await this.$refs.locationTypeRef.$children[0].closeSearchOptions();
          const responseModal = await this.ShowCancelModal(
            'Confirmación',
            'Al cambiar el Tipo de Localización, se eliminará toda la información documentada. ¿Está seguro que desea continuar con la actualización?',
            'Sí',
            'No'
          );
          if (responseModal) {
            this.clear();
            this.locationType = newValue;
            this.model.locationTypeOriginal = newValue;
            this.model.locationTypeId = newValue.id;
          } else {
            this.locationType = this.model.locationTypeOriginal;
            this.model.locationTypeId = this.model.locationTypeOriginal.id;
          }
        }
      } else {
        this.locationType = newValue;
        this.model.locationTypeOriginal = newValue;
        this.model.locationTypeId = newValue.id;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .rounded-circle {
  width: 39px;
  height: 39px;

  em {
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
  }
}
</style>
